import { getItemLocalStorage, setItemLocalStorage } from "@utils/function";
import { MarkFavoritePlayers } from "@components/map/markFavoritePlayers";
import AnalyticsTracking from "@helpers/analyticsTracking";

/**
 * Set favorite players external
 */
export const SetFavoritePlayersFromExternal = () => {
  const getLocalStorage = getItemLocalStorage("HQfavoritePlayers");

  // if getLocalStorage is null or undefined create empty array
  if (!getLocalStorage) {
    setItemLocalStorage("HQfavoritePlayers", []);
  }

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // check if addFav exist in url
  const checkExistAddFav = urlParams.has("addFav");
  if (!checkExistAddFav) return;

  // get addFav value
  const addFavorite = urlParams.get("addFav");

  // split addFav value
  const players = addFavorite.split(",");

  // check if players in localstorage
  players.forEach((player) => {
    const checkExistPlayer = getLocalStorage.includes(+player);

    // if not exist push to localstorage
    if (!checkExistPlayer) {
      getLocalStorage.push(Number(player));

      // tracking
      AnalyticsTracking("setFavoriteExternal", { playerId: player });
    }
  });

  // set localstorage
  setItemLocalStorage("HQfavoritePlayers", getLocalStorage);

  // mark favorite players on map
  MarkFavoritePlayers();
};
